import { graphql } from '@/generated/gql';

export const GET_RULE_HEADER = graphql(/* GraphQL */ `
  query GetRuleHeader($id: UUID!) {
    tesseract {
      rule(id: $id) {
        id
        name
        status
      }
    }
  }
`);
